/** Join class names, dropping falsy entries.
 *
 * Deliberately duplicated from components/utils rather than imported: this
 * folder is meant to be liftable into a shared package as-is, so nothing in
 * it may reach back into CRM code.
 */
export const cls = (...a: (string | false | null | undefined)[]): string =>
  a.filter(Boolean).join(' ')
